import { useQuery } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { apiPatientTasks } from 'services/dataService/resources/oneplatform/api';

import { TASK_POLLING_INTERVAL_MS } from '../constants';

import type { ITasksResponse } from '../types';

export const getTasksByPatientQueryKey = (patientGuid: string) => [
  'getTasksByPatient',
  patientGuid,
];

export const useGetTasksByPatient = (patientGuid: string) => {
  const { t } = useTranslation();

  const { data, ...other } = useQuery({
    queryKey: getTasksByPatientQueryKey(patientGuid),
    queryFn: async () => {
      const { data: taskData, error } =
        await dataService.getList<ITasksResponse>(apiPatientTasks(patientGuid));

      if (error) {
        throw new Error(error);
      }

      return taskData;
    },
    enabled: Boolean(patientGuid),
    refetchInterval: TASK_POLLING_INTERVAL_MS,
    staleTime: 0,
    keepPreviousData: true,
    onError: () => {
      notificationController.error({ message: t('tasksDrawer.errorLoading') });
    },
  });

  return {
    tasks: data?.tasks,
    summary: data?.summary,
    ...other,
  };
};
